import { render, staticRenderFns } from "./base-text-style.vue?vue&type=template&id=5df4b544&scoped=true"
import script from "./base-text-style.vue?vue&type=script&setup=true&lang=js"
export * from "./base-text-style.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-text-style.vue?vue&type=style&index=0&id=5df4b544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4b544",
  null
  
)

export default component.exports